
// 使用：
// <Pageheader title="商户列表" :img="headerimg" :text="headercontent"></Pageheader>
import { defineComponent, ref, reactive, toRefs } from "vue";
export default defineComponent({
  props: ["title", "text", "img"],
  setup(props) {
    const state = reactive({
      headertitle: props.title,
      headercontent: props.text,
      headerimg: props.img,
    });
    return {
      ...toRefs(state),
    };
  },
});
